import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/logo.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
import CloseButton from '~/components/atoms/CloseButton.vue';
export default {
  name: 'LayerFullscreen',
  components: {
    MdmIcon: MdmIcon,
    CloseButton: CloseButton
  }
};